<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  export default {
    data() {
      return {};
    },
  };
</script>
<style lang="scss">
// 全局样式
#app {
  height: 100vh;
}

.el-message-box__message {
  max-height: 400px !important;
  overflow: auto !important;
}
</style>
